import { Button, Form, Input, InputNumber, message, Modal } from 'antd';
import { PmsProductEs, productChangeStock } from 'apis/pms';
import LOCALS from 'commons/locals';
import { PRODUCT_STOCK_TYPE } from 'commons/options';
import i18n from 'i18n';
import { SquarePen } from 'lucide-react';
import { useToggle } from 'react-use';

const ChangeStockButton = ({ product }: { product: PmsProductEs }) => {
  const { skuType, stock } = product;
  const [open, toggleOpen] = useToggle(false);
  const [form] = Form.useForm<{
    changeStock: number;
    note: string;
  }>();

  const changeStock = Form.useWatch('changeStock', form);

  if (skuType !== PRODUCT_STOCK_TYPE.MULTI) return null;

  return (
    <>
      <Modal
        open={open}
        onCancel={toggleOpen}
        title={i18n.t('cmPAiDasco')}
        width={800}
        onOk={async () => {
          const data = await form.validateFields();
          await productChangeStock({
            ...data,
            productId: product.id,
          });

          message.success(i18n.t(LOCALS.successful_operation));
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }}
      >
        <Form
          form={form}
          initialValues={{ changeStock: 0 }}
          labelCol={{ span: 6 }}
        >
          <Form.Item label={i18n.t('vAlezYsIhZ')}>{stock}</Form.Item>
          <Form.Item
            label={i18n.t('zjuDSagfzW')}
            name="changeStock"
            required
            rules={[{ required: true }]}
          >
            <InputNumber min={-stock} className="w-full" />
          </Form.Item>
          <Form.Item label={i18n.t('SDZFKhLlBN')}>
            {stock + changeStock}
          </Form.Item>
          <Form.Item
            label={i18n.t(LOCALS.remark)}
            name="note"
            required
            rules={[{ required: true }]}
          >
            <Input.TextArea></Input.TextArea>
          </Form.Item>
        </Form>
      </Modal>
      <Button type="link" onClick={toggleOpen}>
        <SquarePen />
      </Button>
    </>
  );
};

export default ChangeStockButton;
